module.exports = __webpack_public_path__ + "static/media/hc4.dfa1ebf4.png";